import React from "react";
import { Divider } from "antd";
import ConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";
import PropTypes from "prop-types";

const TrebbleDivider = ({ useEditorTheme, ...restProps }) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <ConfigProvider theme={themeConfig}>
      <Divider {...restProps} />
    </ConfigProvider>
  );
};

TrebbleDivider.propTypes = {
  useEditorTheme: PropTypes.bool
};

export default TrebbleDivider; 